import Vue from 'vue';
import { MapElement } from 'vue-googlemaps/dist/vue-googlemaps.esm';

export default {
  mixins: [MapElement],

  render() {
    return null;
  },

  googleMapsReady() {
    const map = this.$_map;
    const marker = this.$parent.$_marker;
    const vueEl = this.$slots.default;

    const wrapper = new Vue({
      render(h) {
        return h('div', vueEl);
      },
    }).$mount();

    this.$_infowindow = new window.google.maps.InfoWindow({
      content: wrapper.$el,
    });
    this.$_infowindow.open(map, marker);
  },

  beforeDestroy() {
    if (this.$_infowindow) {
      this.$_infowindow.setMap(null);
    }
  },
};
